import React from 'react';
import ReactDOM from 'react-dom';

import { Block, withBlockRendering, withMediaQueryScreenSize } from '../common/Block.jsx';
import Accordion from '../block/Accordion.jsx';
import ArtistImageParallax from '../block/ArtistImageParallax.jsx';
import { ArtistCellContainer } from '../block/ArtistListCell.jsx';
import { ArtistSignupV2 } from '../block/ArtistSignup.jsx';
import BlogImageParallax from '../block/BlogImageParallax.jsx';
import { BlogCellContainer } from '../block/BlogListCell.jsx';
import { Builder, BuilderBlock, PageBottomHiddenDraggable, PageTopHiddenDraggable } from './Builder.jsx';
import { BuilderContainer as ButtonContainer } from '../common/Button.jsx';
import { CardFormV2 } from '../block/CardForm.jsx';
import { Controller as CartController } from '../block/Cart.jsx';
import { InventoryLineItemCellContainer, PromoCodeLineItemCellContainer } from '../block/CartLineItemCell.jsx';
import { ContactFormV2 } from '../block/Contact.jsx';
import * as CookiePolicy from '../block/CookiePolicy.jsx';
import { DesignKit, LegacyThemeStyle, StyleGuide, WhiteLabelStyle } from './CustomizedStyle.jsx'
import Defaults from './Defaults.jsx';
import { default as FontImport } from './FontImport.jsx';
import { Copyright, FooterContainer } from './Footer.jsx';
import { HeaderContainer, SearchBar } from './Header.jsx';
import { default as Image, withMediaQueryImageSize } from '../common/Image.jsx';
import * as InquirePopup from '../block/InquirePopup.jsx';
import InventoryImageParallax from '../block/InventoryImageParallax.jsx';
import { InventoryCellContainer } from '../block/InventoryListCell.jsx';
import Kit from '../layout/Kit.jsx';
import Layout from '../common/Layout.jsx';
import * as Legacy from './Legacy.jsx';
import LocalStorage from '../common/LocalStorage.jsx';
import * as OfferPopup from '../block/OfferPopup.jsx';
import PageType from '../common/PageType.jsx';
import Parallax from '../block/Parallax.jsx';
import { Component as PasswordProtection } from '../block/PasswordProtection.jsx';
import { InventoryModal } from '../common/Popup.jsx';
import * as PostContent from '../block/PostContent.jsx';
import { PromoCodeV2 } from '../block/PromoCodeForm.jsx';
import { Component as PurchasePopup } from '../block/PurchasePopup.jsx';
import { RecentlyViewedCellContainer } from '../block/RecentlyViewedCell.jsx';
import { RepresentativeCellContainer } from '../block/RepresentativeListCell.jsx';
import { SearchResultCellContainer } from '../block/SearchResultCell.jsx';
import { SliderCellContainer } from '../block/SliderCell.jsx';
import ShowImageParallax from '../block/ShowImageParallax.jsx';
import { ShowCellContainer, ShowCellContainerParallax } from '../block/ShowListCell.jsx';
import { SubscribeFormV2 } from '../block/SubscribeForm.jsx';
import { default as SubscribePopup } from '../block/SubscribePopup.jsx';
import { ContentContainer as TabContentContainer } from '../block/Tabs.jsx';
import Types from '../common/Types.jsx';
import Utilities from '../common/Utilities.jsx';

const dropAreaId = 'dropArea';
const mainContentId = 'mainContent';
function _Body(props) {
    const config = props.config || {};
    const data = props.data || {};
    const pageConfig = props.pageConfig || {};

    const mode = props.mode || 'desktop';
    let builderBlockPropsHandler;
    if (props.builder) {
        builderBlockPropsHandler = (d, blockConfig, parentProps) => {
            const blockProps = Builder.handleBlockProps(d, blockConfig, parentProps) || {};
            if (!d.type) {
                return blockProps;
            }
            switch (d.type.value) {
                case Types.Block.Name.Artist.ImageV1:
                case Types.Block.Name.ImageV1:
                case Types.Block.Name.Inventory.Artist.ImageV1: {
                    if (!parentProps.inLayout) {
                        break;
                    }
                    if (d.config && d.config.layout && d.config.layout.maxHeight && d.config.layout.maxHeight.value && d.config.layout.maxHeight.value.length > 0) {
                        break;
                    }
                    if (!blockProps.style || !blockProps.style.width) {
                        if (!blockProps.style) {
                            blockProps.style = {};
                        }
                        blockProps.style.width = '100%';
                    }
                    break;
                }
                case Types.Block.Name.Artist.List: {
                    if (!d.config) {
                        break;
                    }
                    let count = 0;
                    if (d.config.grid && d.config.grid.enabled) {
                        count++;
                    }
                    if (d.config.list && d.config.list.enabled) {
                        count++;
                    }
                    if (d.config.slideshow && d.config.slideshow.enabled) {
                        count++;
                    }
                    if (count > 1) {
                        blockProps.className = 'builder-block-tabbed';
                    }
                    break;
                }
                case Types.Block.Name.Artist.Inventory.ListV1:
                case Types.Block.Name.Artist.Inventory.ListV2:
                case Types.Block.Name.Artist.Inventory.ListV3:
                case Types.Block.Name.Inventory.ListV1:
                case Types.Block.Name.Inventory.ListV2:
                case Types.Block.Name.Inventory.ListV3:
                case Types.Block.Name.Inventory.RelatedV1:
                case Types.Block.Name.Inventory.RelatedV2:
                case Types.Block.Name.Inventory.RelatedV3:
                case Types.Block.Name.Show.Inventory.ListV1:
                case Types.Block.Name.Show.Inventory.ListV2:
                case Types.Block.Name.Show.Inventory.ListV3: {
                    if (!d.config || !d.config.block) {
                        break;
                    }
                    let count = 0;
                    if (d.config.block.hasHorizontalMasonryLayout) {
                        count++;
                    }
                    if (d.config.block.hasPinterestLayout) {
                        count++;
                    }
                    if (d.config.block.hasSlideshowLayout) {
                        count++;
                    }
                    if (d.config.block.hasThumbnailsLayout) {
                        count++;
                    }
                    if (count > 1) {
                        blockProps.className = 'builder-block-tabbed';
                    }
                    break;
                }
                case Types.Block.Name.ButtonV1:
                case Types.Block.Name.Inventory.ControlsV1:
                case Types.Block.Name.Inventory.ControlsV2:
                case Types.Block.Name.Inventory.Button.InquireV1:
                case Types.Block.Name.Inventory.Button.OfferV1:
                case Types.Block.Name.Inventory.Button.PurchaseV1: {
                    let style;
                    if (parentProps.inLayout && d.config && d.config.layout) {
                        if (d.config.layout.maxWidth && d.config.layout.maxWidth.value && d.config.layout.maxWidth.value.length > 0) {
                            if (!style) {
                                style = {};
                            }
                            style.maxWidth = `${d.config.layout.maxWidth.value}${d.config.layout.maxWidth.unit}`;
                        }
                        if (d.config.layout.minWidth && d.config.layout.minWidth.value && d.config.layout.minWidth.value.length > 0) {
                            if (!style) {
                                style = {};
                            }
                            style.minWidth = `${d.config.layout.minWidth.value}${d.config.layout.minWidth.unit}`;
                            style.width = style.minWidth;
                        }
                    }
                    if (style) {
                        if (!blockProps.style) {
                            blockProps.style = {};
                        }
                        Utilities.copyObject(style, blockProps.style);
                    }
                    break;
                }
                case Types.Block.Name.Parallax:
                    blockProps.className = 'builder-block-parallax';
                    break;
                case Types.Block.Name.Slider.Carousel: {
                    let className = 'builder-block-slider';
                    if (d.config && d.config.block && d.config.slides) {
                        const itemsPerSlide = parseInt(d.config.block.items, 10);
                        if (itemsPerSlide >= d.config.slides.length) {
                            className += ' builder-block-slider-static';
                        }
                    }
                    blockProps.className = className;
                    break;
                }
                case Types.Block.Name.Map:
                case Types.Block.Name.Video:
                    if (parentProps.inLayout) {
                        if (!blockProps.style) {
                            blockProps.style = {};
                        }
                        blockProps.style.width = '100%';
                    }
                    break;
            }
            return blockProps;
        }
        if (!props.builderLegacy) {
            // Short circuit to non-page builders
            let cellType;
            switch (props.pageType) {
                case PageType.Footer:
                    return (
                        <React.Fragment>
                            <FooterContainer editor={true} id={dropAreaId} {...props} type={mode} />
                            <GlobalScripts config={config} />
                            <Copyright {...props} type={mode} />
                        </React.Fragment>
                    );
                case PageType.Header:
                    return <HeaderContainer editor={true} id={dropAreaId} {...props} type={mode} />;
                case PageType.Content.InventoryDetailModal:
                case PageType.InventoryDetailModal:
                    return <InventoryModal builderBlockPropsHandler={builderBlockPropsHandler} editor={true} id={dropAreaId} {...props} />
                case PageType.Content.Accordion:
                    return <Accordion.ContentContainer editor={true} id={dropAreaId} {...props} />
                case PageType.Content.ArtistCell.Grid:
                    cellType = 'grid';
                // Intentional fallthrough
                case PageType.Content.ArtistCell.List:
                    cellType = cellType || 'list';
                // Intentional fallthrough
                case PageType.Content.ArtistCell.ListPreview:
                    cellType = cellType || 'listPreview';
                // Intentional fallthrough
                case PageType.Content.ArtistCell.Slideshow:
                    return <ArtistCellContainer editor={true} id={dropAreaId} {...props} type={cellType || 'slideshow'} />;
                case PageType.Content.ArtistImageParallax:
                    return <ArtistImageParallax.Cell editor={true} id={dropAreaId} {...props} />
                case PageType.Content.ArtistTab:
                case PageType.Content.ExhibitionTab:
                case PageType.Content.Tab:
                    return <TabContentContainer builderBlockPropsHandler={builderBlockPropsHandler} editor={true} id={dropAreaId} {...props} />;
                case PageType.Content.BlogCell:
                    return <BlogCellContainer editor={true} id={dropAreaId} {...props} />
                case PageType.Content.BlogImageParallax:
                    return <BlogImageParallax.Cell editor={true} id={dropAreaId} {...props} />
                case PageType.Content.Button.Primary:
                case PageType.Content.Button.Secondary:
                    const blockConfig = props.activeConfigBlock && props.activeConfigBlock.config || props.contentConfig && props.contentConfig.config;
                    return <ButtonContainer id={dropAreaId} {...props} blockConfig={blockConfig} />
                case PageType.Content.Cart.InventoryLineItemCell:
                    return <InventoryLineItemCellContainer editor={true} id={dropAreaId} {...props} />
                case PageType.Content.Cart.PromoCodeLineItemCell:
                    return <PromoCodeLineItemCellContainer editor={true} id={dropAreaId} {...props} />
                case PageType.Content.InventoryCell.Grid:
                    cellType = 'grid';
                // Intentional fallthrough
                case PageType.Content.InventoryCell.Slideshow:
                case PageType.Content.InventoryCell.SlideshowV2:
                    cellType = cellType || 'slideshow';
                // Intentional fallthrough
                case PageType.Content.InventoryCell.Waterfall:
                    return <InventoryCellContainer backgroundColor={props.onBackgroundColor && props.onBackgroundColor()} cellType={cellType || 'waterfall'} editor={true} id={dropAreaId} inCell={true} v3={props.pageType == PageType.Content.InventoryCell.SlideshowV2} {...props} />;
                case PageType.Content.InventoryImageParallax:
                    return <InventoryImageParallax.Cell editor={true} id={dropAreaId} {...props} />;
                case PageType.Content.Media:
                    return <PostContent.ContentContainer editor={true} id={dropAreaId} {...props} />;
                case PageType.Content.ExhibitionCell.Parallax:
                    return <ShowCellContainerParallax editor={true} id={dropAreaId} {...props} />;
                case PageType.Content.ExhibitionCell.Grid:
                    cellType = 'grid';
                // Intentional fallthrough
                case PageType.Content.ExhibitionCell.Slideshow:
                    return <ShowCellContainer editor={true} id={dropAreaId} {...props} type={cellType || 'slideshow'} />;
                case PageType.Content.ExhibitionImageParallax:
                    return <ShowImageParallax.Cell editor={true} id={dropAreaId} {...props} />
                case PageType.Content.Parallax:
                    return <Parallax.Cell editor={true} id={dropAreaId} {...props} />;
                case PageType.Content.RecentlyViewedCell:
                    return <RecentlyViewedCellContainer editor={true} id={dropAreaId} {...props} />;
                case PageType.Content.RepresentativeCell:
                    return <RepresentativeCellContainer editor={true} id={dropAreaId} {...props} />
                case PageType.Content.SearchResultCell.Artist:
                case PageType.Content.SearchResultCell.Blog:
                case PageType.Content.SearchResultCell.Exhibition:
                case PageType.Content.SearchResultCell.Inventory:
                    return <SearchResultCellContainer editor={true} id={dropAreaId} {...props} />;
                case PageType.Content.Slide:
                    return <SliderCellContainer editor={true} id={dropAreaId} {...props} />;
                case PageType.CookiePolicy:
                    return <CookiePolicy.Component editor={true} id={dropAreaId} {...props} />;
                case PageType.Form.ArtistSignup:
                    return <ArtistSignupV2.Component editor={true} id={dropAreaId} {...props} />;
                case PageType.Form.Cart.Card:
                    return <CardFormV2.Component editor={true} id={dropAreaId} {...props} />;
                case PageType.Form.Cart.PromoCode:
                    return <PromoCodeV2.Component editor={true} id={dropAreaId} {...props} />;
                case PageType.Form.Contact:
                    return <ContactFormV2.Component editor={true} id={dropAreaId} {...props} />;
                case PageType.Form.Inquire:
                    return <InquirePopup.InquireForm.Component editor={true} id={dropAreaId} {...props} />;
                case PageType.Form.FooterSubscribe:
                    return <SubscribeFormV2.Footer editor={true} id={dropAreaId} {...props} />;
                case PageType.Form.HeaderSearch:
                    return <SearchBar editor={true} id={dropAreaId} isV2={true} {...props} />;
                case PageType.Form.Offer:
                    return <OfferPopup.OfferForm.Component editor={true} id={dropAreaId} {...props} />;
                case PageType.Form.Subscribe:
                    return <SubscribeFormV2.CustomPage editor={true} id={dropAreaId} inPopup={true} {...props} />;
                case PageType.Popup.Inquire:
                    return <InquirePopup.Component backgroundColor={props.onBackgroundColor && props.onBackgroundColor()} editor={true} id={dropAreaId} {...props} />;
                case PageType.Popup.Offer:
                    return <OfferPopup.Component backgroundColor={props.onBackgroundColor && props.onBackgroundColor()} editor={true} id={dropAreaId} {...props} />;
                case PageType.Popup.Purchase:
                    const inventory = props.data && props.data.inventory && props.data.inventory.length > 0 && props.data.inventory[0] || {};
                    return <PurchasePopup backgroundColor={props.onBackgroundColor && props.onBackgroundColor()} editor={true} id={dropAreaId} inventory={inventory} {...props} />;
                case PageType.Popup.Subscribe:
                    return <SubscribePopup backgroundColor={props.onBackgroundColor && props.onBackgroundColor()} editor={true} id={dropAreaId} {...props} />;
            }
        }
    }

    // Fixed header top offset updates
    React.useEffect(() => {
        if (!props.config.documents || !props.config.documents.header) {
            return;
        }
        if (!props.config.layout) {
            return;
        }
        // Inject header custom page top offset from document configuration
        const layout = props.config.layout.toLowerCase();
        let html;
        if (props.config.documents.header.desktop &&
            props.config.documents.header.desktop.page &&
            props.config.documents.header.desktop.page.config &&
            props.config.documents.header.desktop.page.config.block &&
            props.config.documents.header.desktop.page.config.block.position == 'fixed') {
            const pageTopOffset = Block.getStyleConfigPropValue('pageTopOffset', config.documents.header.desktop.page.config.block);
            if (pageTopOffset) {
                html = `@media (min-width: 768px) { .tennies .${layout} { padding-top: ${pageTopOffset} } } `;
            }
        }
        if (props.config.documents.header.mobile &&
            props.config.documents.header.mobile.page &&
            props.config.documents.header.mobile.page.config &&
            props.config.documents.header.mobile.page.config.block &&
            props.config.documents.header.mobile.page.config.block.position == 'fixed') {
            const pageTopOffset = Block.getStyleConfigPropValue('pageTopOffset', config.documents.header.mobile.page.config.block);
            if (pageTopOffset) {
                if (!html) {
                    html = '';
                }
                html += `@media (max-width: 767px) { .tennies .${layout} { padding-top: ${pageTopOffset} } }`;
            }
        }
        if (!html) {
            return;
        }
        const elements = document.getElementsByClassName(layout);
        if (!elements || elements.length == 0) {
            return;
        }
        const style = document.createElement('STYLE');
        style.innerHTML = html;
        elements[0].parentNode.insertBefore(style, elements[0]);
    }, []);

    // Recently Viewed local storage update
    React.useEffect(() => {
        if (props.builder || props.pageType != PageType.InventoryDetail || !props.data || !props.data.inventory) {
            return;
        }
        LocalStorage.RecentlyViewed.put(props.data.inventory);
    }, []);

    const [passwordRequired, setPasswordRequired] = React.useState(!props.builder && pageConfig.isProtected);
    if (!data.config) {
        // Fallback to default page config
        switch (props.pageType) {
            case PageType.Cart:
                data.config = Defaults.PageConfig[PageType.Cart](config);
                break;
            case PageType.SearchResults:
                data.config = Defaults.PageConfig[PageType.SearchResults](config);
                break;
        }
    }
    let backgroundColor = config.colors && config.colors.bodyBackground;
    let contentStyle = {};
    let legacy = false;
    let body, topHiddenOffset;
    if (props.builder && props.builderLegacy) {
        body = (
            <div className="sect p-t-0">
                <div className="editor__content">
                    <div id="contentarea" className="is-container container"></div>
                </div>
            </div>
        );
        legacy = true;
    } else if ((props.builder && !props.builderLegacy) || props.pageType == PageType.Cart || (data.config && data.config.desktop && data.config.desktop.blocks && data.config.desktop.blocks.length > 0) || (pageConfig.blocks && pageConfig.blocks.length > 0)) {
        let callback;
        let blocks = data.config && data.config.desktop && data.config.desktop.blocks;
        legacy = !props.builder && (!blocks || blocks.length == 0)
        if (!blocks && pageConfig.blocks) {
            blocks = pageConfig.blocks;
            callback = () => { return { legacy, legacyData: props.data } };
        }
        const propertyHandler = (propName, propValue) => {
            let skipPlacement;
            switch (props.pageType) {
                case PageType.Content.Blog:
                case PageType.Custom:
                    skipPlacement = true;
                    break;
            }
            switch (propName) {
                case 'maxWidth':
                    return skipPlacement;
                case 'paddingTop':
                    topHiddenOffset = propValue;
                    break;
                case 'textAlign':
                    if (skipPlacement) {
                        return true;
                    }
                    switch (propValue) {
                        case 'center':
                            contentStyle.marginLeft = 'auto';
                            contentStyle.marginRight = 'auto';
                            break;
                        case 'left':
                            contentStyle.marginRight = 'auto';
                            break;
                        case 'right':
                            contentStyle.marginLeft = 'auto';
                            break;
                    }
                    return true;
            }
        }
        let pageProps;
        if (props.onPageProps) {
            pageProps = props.onPageProps();

            let configProps;
            for (let configName in pageProps.config) {
                configProps = pageProps.config[configName];
                Block.mapStyleConfigProps(contentStyle, configProps, propertyHandler);
            }
            pageProps = pageProps.config;
        } else if (data.config && data.config[mode] && data.config[mode].page && data.config[mode].page.config) {
            pageProps = data.config[mode].page.config;
            if (pageProps.layout) {
                Block.mapStyleConfigProps(contentStyle, pageProps.layout, propertyHandler);
            }
        }
        if (pageProps && pageProps.block && pageProps.block.backgroundColor) {
            backgroundColor = pageProps.block.backgroundColor;
        }
        if (props.renderHeaderFooter != false) {
            Kit.Page.updateComponentStyle(contentStyle, props.config, props.pageType, ['marginBottom', 'marginTop', 'paddingBottom', 'paddingTop']);
        }
        if (!legacy) {
            if (!props.builder) {
                callback = () => { return { backgroundColor, pageConfig: props.data && props.data.config, pageType: props.pageType } };
            } else {
                callback = () => { return { backgroundColor, renderHeaderFooter: props.renderHeaderFooter, onBlankState: props.onBlankState } };
            }
        }

        const bodyProps = {};
        let wrapperClassName;
        switch (props.pageType) {
            case PageType.Cart:
                body = <CartController {...props} backgroundColor={backgroundColor} builderBlockPropsHandler={builderBlockPropsHandler} style={contentStyle} />
                bodyProps.className = 'cont--cart';
                contentStyle = undefined;
                legacy = false;
                break;
            case PageType.Custom:
                if (legacy) {
                    bodyProps.className = 'sect p-t-0';
                    wrapperClassName = 'editor__content';
                } else if (passwordRequired) {
                    body = <PasswordProtection config={config} pageId={pageConfig.pageId} recaptcha={false} onComplete={() => setPasswordRequired(false)} />
                }
                break;
            case 'notFound':
                const componentData = Types.Block.getComponentAndData({ type: { value: props.pageType } }, props.pageType);
                if (componentData && componentData.component) {
                    body = <componentData.component />
                }
                break;
        }
        if (!body) {
            body = props.onBlockRendering(props.pageType, blocks || [], callback, builderBlockPropsHandler);
        }
        if (props.builder) {
            if (props.dragging) {
                if (bodyProps.className) {
                    bodyProps.className += ' dragging';
                } else {
                    bodyProps.className = 'dragging';
                }
            }
            bodyProps.id = dropAreaId;
            bodyProps.onDragEnter = props.onDragEnter;
            bodyProps.onDragOver = (e) => { if (e) { e.preventDefault() } }
            bodyProps.onDrop = props.onDrop;

            body = (
                <React.Fragment>
                    <PageTopHiddenDraggable adjustTop={true} offset={topHiddenOffset} onDragEnter={props.onDragEnter} />
                    {body}
                    <PageBottomHiddenDraggable onDragEnter={props.onDragEnter} />
                </React.Fragment>
            );
        }
        if (wrapperClassName) {
            body = <div className={wrapperClassName}>{body}</div>
        }
        body = <div {...bodyProps}>{body}</div>
    } else if (data.blocks) {
        body = props.onBlockRendering(props.pageType, data.blocks, () => { return { legacy: true, legacyData: props.data } });
        legacy = true;
    } else {
        // Cart, Legacy Blog Post Details
        const componentData = Types.Block.getComponentAndData({ type: { value: props.pageType } }, props.pageType, props.data, config);
        if (componentData && componentData.component) {
            body = (
                <componentData.component
                    baseUrl={props.baseUrl}
                    config={config}
                    data={componentData.data || props.data}
                    frameDoc={props.frameDoc}
                    handlerUrl={props.handlerUrl}
                    queryDataSub={props.queryDataSub}
                    queryLayout={props.queryLayout}
                    querySub={props.querySub} />
            );
            if (props.builder) {
                body = (
                    <BuilderBlock
                        blockConfig={config}
                        blockType={props.pageType}
                        dragging={props.dragging}
                        onBlockClick={props.onBlockClick}
                        onBlockMove={props.onBlockMove}
                        onBlockProps={props.onBlockProps}
                        onDragOver={props.onDragOver}
                        onDragStart={props.onDragStart}>
                        {body}
                    </BuilderBlock>
                );
            }
        }
        legacy = true;
    }
    const header = (
        <PageHeader
            baseUrl={props.baseUrl}
            builder={props.builder}
            config={config}
            handlerUrl={props.handlerUrl}
            imageSize={props.imageSize}
            pageId={props.pageId}
            queryDataSub={props.queryDataSub}
            queryLayout={props.queryLayout}
            querySub={props.querySub} />
    );
    let content;
    switch (props.pageType) {
        case PageType.Cart:
        case PageType.InventoryDetail: {
            let className = 'artwork__outer';
            if (!legacy) {
                className += ' cont--whitelabel';
            }
            if (props.builder) {
                className += ' builder';
                if (props.dragging) {
                    className += ' dragging';
                }
            }
            content = (
                <React.Fragment>
                    {
                        props.renderHeaderFooter != false &&
                        <section className="sect--inner">
                            {header}
                        </section>
                    }
                    <section id={mainContentId} className={className} style={contentStyle}>
                        {body}
                    </section>
                </React.Fragment>
            );
            break;
        }
        default: {
            if (props.isHomePage) {
                if (!legacy) {
                    body = <div id={mainContentId} className="cont--whitelabel" style={contentStyle}>{body}</div>
                }
                content = (
                    <React.Fragment>
                        {props.renderHeaderFooter != false && header}
                        {body}
                    </React.Fragment>
                );
                break;
            }
            let className = 'sect';
            if (!legacy) {
                className += ' cont--whitelabel';
            }
            let pageTitle = props.pageTitle;
            let pageTitleVisible = props.pageTitleVisible;
            if (props.builder) {
                className += ' builder';
                if (props.dragging) {
                    className += ' dragging';
                }
                if (props.pageType == PageType.Custom && props.data) {
                    pageTitle = props.data.title;
                    pageTitleVisible = props.data.isTitleVisible;
                }
            }
            content = (
                <React.Fragment>
                    {
                        props.renderHeaderFooter != false &&
                        <section className="sect--inner">
                            {header}
                            {
                                legacy &&
                                <_ClassicCover
                                    config={config}
                                    data={props.data}
                                    pageTitle={pageTitle}
                                    pageTitleVisible={pageTitleVisible}
                                    pageType={props.pageType} />
                            }
                        </section>
                    }
                    <div id={mainContentId} className={className} style={contentStyle}>
                        {
                            legacy &&
                            pageTitleVisible &&
                            pageTitle &&
                            pageTitle.length > 0 &&
                            <div className="cont">
                                <_Cover
                                    config={config}
                                    data={props.data}
                                    pageTitle={pageTitle}
                                    pageType={props.pageType} />
                            </div>
                        }
                        {body}
                    </div>
                </React.Fragment>
            );
            break;
        }
    }
    if (!legacy) {
        switch (props.pageType) {
            case PageType.Cart:
                break;
            default:
                React.useEffect(() => {
                    if (props.builder) {
                        return;
                    }
                    document.body.style.backgroundColor = props.data.config.desktop.page.config.block.backgroundColor || '';
                }, [props.data.config.desktop.page.config.block.backgroundColor]);
                break;
        }
    }
    return (
        <React.Fragment>
            {content}
            {
                !props.builder &&
                config.popupDelay != null &&
                <SubscribePopup config={config} sub={config.subdomain} />
            }
            {
                props.renderHeaderFooter != false &&
                <PageFooter
                    baseUrl={props.baseUrl}
                    builder={props.builder}
                    config={config}
                    handlerUrl={props.handlerUrl}
                    imageSize={props.imageSize}
                    queryDataSub={props.queryDataSub}
                    queryLayout={props.queryLayout}
                    querySub={props.querySub} />
            }
            {
                !props.builder &&
                <CookiePolicy.Component config={config} />
            }
            {
                props.pageType == 'cart' &&
                <script type="text/javascript" src="https://js.stripe.com/v2/"></script>
            }
        </React.Fragment>
    );
}
const Body =
    withMediaQueryImageSize(
        withMediaQueryScreenSize(
            withBlockRendering(_Body)));

function Head(props) {
    const config = props.config || {};
    let html = `
        body {
            margin: 0 !important;
            padding: 0 !important;
            min-width: 100% !important;
            width: 100% !important;
        }
    `;
    if (props.styles) {
        html += props.styles;
    }
    const styles = <style dangerouslySetInnerHTML={{ __html: html }} />;

    let stylesheet;
    if (config.layout && props.handlerUrl) {
        stylesheet = [
            <link key="0" rel="stylesheet" href={`${props.handlerUrl}/css/${config.layout.toLowerCase()}/builder-theme.css`} />,
            <link key="1" rel="stylesheet" href={`${props.handlerUrl}/css/whitelabel/builder-theme.css`} />
        ];
    }
    return (
        <React.Fragment>
            <meta charSet="utf-8" />
            <meta httpEquiv="Content-type" content="text/html; charset=utf-8" />
            <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1" />
            <meta httpEquiv="X-UA-Compatible" content="IE=edge,chrome=1" />
            <FontImport.Custom font={config.headerFont} />
            <FontImport.Custom font={config.bodyFont} />
            <FontImport.Google config={config} />
            {stylesheet}
            <LegacyThemeStyle config={config} />
            <WhiteLabelStyle config={config} />
            <DesignKit builder={props.builder} config={config} />
            {styles}
        </React.Fragment>
    )
}

// region COMPONENTS

function GlobalScripts(props) {
    if (!props.config || !props.config.footer || props.config.footer.length == 0) {
        return null;
    }
    return <div className="foot__custom" dangerouslySetInnerHTML={{ __html: props.config.footer }} style={{ height: 0, display: 'none' }} />
}

function PageFooter(props) {
    const config = props.config || {};
    if (!config.documents || !config.documents.footer || !config.documents.footer.desktop || !config.documents.footer.desktop.blocks || config.documents.footer.desktop.blocks.length == 0) {
        // Legacy desktop/mobile footer
        return (
            <Legacy.Footer
                baseUrl={props.baseUrl}
                builder={props.builder}
                config={config}
                queryDataSub={props.queryDataSub}
                queryLayout={props.queryLayout}
                querySub={props.querySub} />
        );
    }
    let footerMobile;
    if (config.documents.footer.mobile && config.documents.footer.mobile.blocks && config.documents.footer.mobile.blocks.length > 0) {
        // Custom mobile footer
        footerMobile = (
            <FooterContainer
                baseUrl={props.baseUrl}
                config={config}
                contentConfig={config.documents.footer}
                disabled={props.builder}
                handlerUrl={props.handlerUrl}
                imageSize={props.imageSize}
                queryDataSub={props.queryDataSub}
                queryLayout={props.queryLayout}
                querySub={props.querySub}
                type="mobile" />
        );
    } else {
        // Default white-label mobile footer ("legacy" but not)
        config.documents.footer.mobile = Defaults.MobileConfig[PageType.Footer](config);
        footerMobile = (
            <FooterContainer
                baseUrl={props.baseUrl}
                config={config}
                contentConfig={config.documents.footer}
                disabled={props.builder}
                handlerUrl={props.handlerUrl}
                imageSize={props.imageSize}
                queryDataSub={props.queryDataSub}
                queryLayout={props.queryLayout}
                querySub={props.querySub}
                type="mobile" />
        );
    }
    return (
        <React.Fragment>
            <FooterContainer
                baseUrl={props.baseUrl}
                config={config}
                contentConfig={config.documents.footer}
                disabled={props.builder}
                handlerUrl={props.handlerUrl}
                imageSize={props.imageSize}
                queryDataSub={props.queryDataSub}
                queryLayout={props.queryLayout}
                querySub={props.querySub}
                type="desktop" />
            {footerMobile}
            <GlobalScripts config={config} />
            <Copyright
                builder={props.builder}
                config={config}
                contentConfig={config.documents.footer}
                disabled={props.builder}
                type="desktop" />
            <Copyright
                builder={props.builder}
                config={config}
                contentConfig={config.documents.footer}
                disabled={props.builder}
                type="mobile" />
        </React.Fragment>
    );
}

function PageHeader(props) {
    const config = props.config || {};
    let header, headerMobile;
    if (config.documents && config.documents.header && config.documents.header.desktop && config.documents.header.desktop.blocks && config.documents.header.desktop.blocks.length > 0) {
        // Custom desktop header
        header = (
            <HeaderContainer
                baseUrl={props.baseUrl}
                config={config}
                contentConfig={config.documents.header}
                disabled={props.builder}
                handlerUrl={props.handlerUrl}
                imageSize={props.imageSize}
                mainContentId={mainContentId}
                pageId={props.pageId}
                queryDataSub={props.queryDataSub}
                queryLayout={props.queryLayout}
                querySub={props.querySub}
                type="desktop" />
        );
        if (config.documents.header.mobile && config.documents.header.mobile.blocks && config.documents.header.mobile.blocks.length > 0) {
            // Custom mobile header
            headerMobile = (
                <HeaderContainer
                    baseUrl={props.baseUrl}
                    config={config}
                    contentConfig={config.documents.header}
                    disabled={props.builder}
                    handlerUrl={props.handlerUrl}
                    imageSize={props.imageSize}
                    pageId={props.pageId}
                    queryDataSub={props.queryDataSub}
                    queryLayout={props.queryLayout}
                    querySub={props.querySub}
                    type="mobile" />
            );
        } else {
            // Default white-label mobile header ("legacy" but not)
            const isFixed = config.documents.header.desktop.page && config.documents.header.desktop.page.config && config.documents.header.desktop.page.config.block && config.documents.header.desktop.page.config.block.position == 'fixed';
            config.documents.header.mobile = Defaults.MobileConfig[PageType.Header](config, isFixed);
            headerMobile = (
                <HeaderContainer
                    baseUrl={props.baseUrl}
                    config={config}
                    contentConfig={config.documents.header}
                    disabled={props.builder}
                    handlerUrl={props.handlerUrl}
                    imageSize={props.imageSize}
                    pageId={props.pageId}
                    queryDataSub={props.queryDataSub}
                    queryLayout={props.queryLayout}
                    querySub={props.querySub}
                    type="mobile" />
            );
        }
    } else {
        // Legacy desktop/mobile header
        header = (
            <Legacy.Header
                baseUrl={props.baseUrl}
                builder={props.builder}
                config={config}
                pageId={props.pageId}
                queryDataSub={props.queryDataSub}
                queryLayout={props.queryLayout}
                querySub={props.querySub} />
        );
    }
    return (
        <React.Fragment>
            {header}
            {headerMobile}
        </React.Fragment>
    );
}

// region COVER

function _ClassicCover(props) {
    let layout = props.config.layout;
    if (layout) {
        layout = layout.toLowerCase();
    }
    if (layout != Layout.Type.Theme.Classic) {
        return null;
    }
    let coverContent;
    switch (props.pageType) {
        case PageType.ExhibitionDetail:
            let data = props.data || {};
            data = data.show;
            coverContent = (
                <div className="sect--intro__content">
                    <h1 className="sect--intro__title--lg">{data.title}</h1>
                    {
                        data.date &&
                        data.date.length > 0 &&
                        <div className="artist__header__details">{data.date}</div>
                    }
                </div>
            );
            break;
        default:
            coverContent = <h1 className="typ layout__page__header">{props.pageTitle}</h1>;
            break;
    }
    let imageUrl = '/images/bg.png'
    if (props.config.cover) {
        imageUrl = Image.url(props.config.cover, undefined, undefined, undefined, imageUrl);
    }
    coverContent = (
        <div className="cover cover--bg">
            <div className="cover--bg__area"
                data-0="transform: translateY(6%);"
                data-500="transform: translateY(24%);"
                style={{ backgroundImage: `url('${imageUrl}')` }} />
            {
                coverContent != undefined &&
                <div className="cont">
                    <div className="cover__content">
                        {coverContent}
                    </div>
                </div>
            }
        </div>
    );
    return coverContent;
}

function _Cover(props) {
    let layout = props.config.layout;
    if (layout) {
        layout = layout.toLowerCase();
    }
    if (layout == Layout.Type.Theme.Classic) {
        return null;
    }
    let coverContent = null;
    switch (props.pageType) {
        case PageType.ArtistDetail:
        case PageType.Content.Blog:
        case PageType.ExhibitionDetail:
            break;
        default:
            coverContent = (
                <h1 className="typ--main layout__page__header">
                    <div className="typ--main__inn">{props.pageTitle}</div>
                </h1>
            );
            break;
    }
    return coverContent;
}

// region FRAME

class Frame extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            frameDoc: undefined
        };

        this.handleFrameDocument = this.handleFrameDocument.bind(this);
    }

    handleFrameDocument(frameDoc) {
        if (this.state.frameDoc) {
            return;
        }
        this.setState({
            frameDoc: frameDoc
        });
    }

    render() {
        return (
            <FrameContainer head={<Head {...this.props} />} onFrameDocument={this.handleFrameDocument} {...this.props}>
                <Body frameDoc={this.state.frameDoc} {...this.props} />
            </FrameContainer>
        );
    }
}

class FrameContainer extends React.Component {
    constructor(props) {
        super(props);

        this._cancelRender = this._cancelRender.bind(this);
        this.renderFrameContent = this.renderFrameContent.bind(this);
    }

    componentDidMount() {
        this.renderFrameContent();
    }

    componentDidUpdate() {
        this.renderFrameContent();
    }

    componentWillUnmount() {
        this._cancelRender();
    }

    _cancelRender() {
        if (this.renderHandle) {
            clearTimeout(this.renderHandle);
            this.renderHandle = null;
        }
    }

    renderFrameContent() {
        if (this.updater && this.updater.isMounted && this.updater.isMounted(this)) {
            const temp = ReactDOM.findDOMNode(this);
            const doc = temp.contentDocument;
            if (doc && doc.readyState === 'complete' && doc.getElementById('frameContent') != null) {
                if (this.props.onFrameDocument) {
                    this.props.onFrameDocument(doc);
                }
                ReactDOM.render(this.props.head, doc.head);

                const contentContainer = doc.getElementById('frameContent');
                if (contentContainer && contentContainer.children && contentContainer.children.length == 0 && this.props.onLoad) {
                    const component = this;
                    setTimeout(function () {
                        component.props.onLoad({ currentTarget: temp });
                    }, 10);
                }
                ReactDOM.render(this.props.children, contentContainer);

                const body = doc.getElementsByTagName('BODY');
                if (!body || !body.length) {
                    return;
                }
                body[0].className = 'tennies';
                if (this.props.data && this.props.data.slug) {
                    body[0].setAttribute('page', this.props.data.slug);
                    body[0].setAttribute('data-page', this.props.data.slug);
                }
                return;
            }
        }
        // Wait for the iframe to be ready
        this._cancelRender();
        this.renderHandle = setTimeout(this.renderFrameContent, 0);
    }

    render() {
        return <iframe id={this.props.id || this.props.pageId} srcDoc={`<div id='frameContent' class='${this.props.className}' />`} style={this.props.style} />;
    }
}

export { Body, Defaults, DesignKit, Frame, Layout, StyleGuide, Types, Utilities };